// Client-side mirror of scripts/lib/routes.js's BLOG_LOCALE_PREFIXES.
// Duplicated, not imported: that file is a Node CJS module (uses
// fs/path) never bundled into the browser build. Both must stay in sync
// by hand -- there are only three locales, so this is cheap to keep in
// sync and cheaper than inventing a shared-build-time-constant mechanism
// for one three-entry map.
export const BLOG_LOCALE_PREFIXES = { fi: '', ru: '/ru', en: '/en' };

export function blogIndexPath(locale) {
  return `${BLOG_LOCALE_PREFIXES[locale]}/blog`;
}

export function blogArticlePath(locale, slug) {
  return `${blogIndexPath(locale)}/${slug}`;
}